// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box {
  position: relative;
  min-height: 89.98px;
  width: 100%;
  padding: 0 7.5px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 22px;
  background: #fff;
}
.box::before {
  border-radius: 8px;
  content: "";
  background-image: var(--border-color, linear-gradient(to top, #84f4bc 0%, #ffb380 100%));
  top: -1.5px;
  left: -1.5px;
  bottom: -1.5px;
  right: -1.5px;
  position: absolute;
  z-index: -1;
}
@media (max-width: 320px) {
  .box {
    gap: 5px;
    padding: 0 7.5px 0 7.5px;
  }
}
.box img {
  margin-bottom: 3px;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .box img {
    width: 40%;
  }
}
.box h6 {
  text-align: center;
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/components/tip-block/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA;EACA,wFAAA;EAIA,WAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;AAFJ;AAKE;EA3BF;IA4BI,QAAA;IACA,wBAAA;EAFF;AACF;AAIE;EACE,kBAAA;EACA,cAAA;AAFJ;AAII;EAJF;IAKI,UAAA;EADJ;AACF;AAIE;EACE,kBAAA;EACA,SAAA;AAFJ","sourcesContent":[".box {\n  position: relative;\n  min-height: 89.98px;\n  width: 100%;\n  padding: 0 7.5px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 22px;\n  background: #fff;\n\n  &::before {\n    border-radius: 8px;\n    content: \"\";\n    background-image: var(\n      --border-color,\n      linear-gradient(to top, #84f4bc 0%, #ffb380 100%)\n    );\n    top: -1.5px;\n    left: -1.5px;\n    bottom: -1.5px;\n    right: -1.5px;\n    position: absolute;\n    z-index: -1;\n  }\n\n  @media (max-width: 320px) {\n    gap: 5px;\n    padding: 0 7.5px 0 7.5px;\n  }\n\n  img {\n    margin-bottom: 3px;\n    flex-shrink: 0;\n\n    @media (max-width: 768px) {\n      width: 40%;\n    }\n  }\n\n  h6 {\n    text-align: center;\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
